import { ApiHttpClient } from "../../common/http/api-http-client";
import { HttpRequest } from "../../common/http/http-request";
import { ClientDto } from "./client.dto";
import { CreateClientDto } from "./create-client.dto";
import { UpdateClientDto } from "./update-client.dto";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { merge } from "lodash";
import { mapClientToOptionType } from "./client-option.utils";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ClientsResource extends ResourceBaseService<ClientDto, CreateClientDto, UpdateClientDto> {
  protected EntityDto = ClientDto;
  protected CreateEntityDto = CreateClientDto;
  protected UpdateEntityDto = UpdateClientDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/clients");
  }

  async optionLoader(inputValue: string, customRequest?: IRequest): Promise<OptionType[]> {
    const request: IRequest = inputValue
      ? { search: inputValue, searchBy: ["id", "name", "vatNumber", "sapCode"] }
      : {};
    request.sortBy = "name";
    if (customRequest) merge(request, customRequest);
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => mapClientToOptionType(value));
  }

  async importClients(file: File): Promise<{ status: "queued"; jobId: string }> {
    const formData = new FormData();
    formData.append("file", file);

    return this.apiHttpClient.request<FormData, { status: "queued"; jobId: string }>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/import",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }

  async downloadClientsImportTemplate(): Promise<void> {
    return this.downloadExcel(null, "/import/template", "plantilla-clientes");
  }
}
